import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { ErrorResponse, signUpNewPatient } from "~/patients/api";

export const useCreateNewPatient = (onSignUpSuccess: () => void) => {
  return useMutation({
    mutationFn: signUpNewPatient,
    onSuccess: onSignUpSuccess,
    onError: (error: ErrorResponse) => {
      const errorMessage =
        error.response?.data.detail ??
        "There was an issue registering your account. Please try again later.";
      toast.error(errorMessage);
    },
  });
};
